module.exports = __webpack_public_path__ + "img/4.948de6c9.jpg";